import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import orderAddressSlice from './address-slice'
import { OrderAddressValue } from './address-types'
import { makeOrderAddressValidationSchema } from './address-utils'

const useOrderAddress = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const schema = makeOrderAddressValidationSchema()
  const { value } = useSelector((state: RootState) => state.order.address)

  const setValue = useCallback(
    (value: OrderAddressValue) => {
      dispatch(orderAddressSlice.actions.setValue(value))
    },
    [dispatch],
  )

  return useMemo(
    () => ({
      value,
      setValue,
      schema,
    }),
    [value, setValue, schema],
  )
}

export default useOrderAddress
